module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-7.c1ead38c.png";